var module = angular.module('octopusApp.projects');

module.directive('actionSummary', function($templateCache, $compile, $injector, octopusLog, pluginRegistry, octopusClient) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      action: '=',
      step: '=',
      number: '=',
      editLink: '='
    },
    templateUrl: 'areas/projects/views/action_summary.html',
    link: function(scope, element) {
      var action = scope.action;
      var step = scope.step;
      if (!action || !step) {
        return;
      }

      scope.isSingleStep = step.Actions.length === 1;
      scope.properties = $.extend({}, action.Properties, step.Properties);

      octopusLog.info("Finding registered deployment action for action type: " + action.ActionType);

      var plugin = pluginRegistry.getDeploymentAction(action.ActionType);
      if (!plugin) {
        octopusLog.error("Unknown action type: ", action.ActionType);
        return;
      }

      var templateId = action.Properties['Octopus.Action.Template.Id'];
      var version = action.Properties['Octopus.Action.Template.Version'];

      scope.logoUrl =  templateId ?
          octopusClient.resolveLinkTemplate("ActionTemplateVersionedLogo", {typeOrId : templateId, version: version}) :
          octopusClient.resolveLinkTemplate("ActionTemplateLogo", {typeOrId : action.ActionType});

      var viewTemplateUrl = plugin.summaryTemplateUrl;
      octopusLog.info("Resolving view template: ", viewTemplateUrl);

      var template = $templateCache.get(viewTemplateUrl);
      if (!template) {
        octopusLog.info("Could not find view template in the template cache: ", viewTemplateUrl);
        return;
      }

      var child = $compile(template)(scope);
      if (plugin.summaryLink) {
        plugin.summaryLink(scope, child);
      }

      var actionBody = $('.action-details', element);
      actionBody.html('');
      actionBody.html(child);
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/action_summary.js
// module id = 5705995614996106
// module chunks = 1